import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { ParametersProvider } from './context/parameters-context';
import { ParametersComponent } from './parameters-component';

export function ParametersFactory() {
    return (
        <BaseLayoutFactory>
            <ParametersProvider>
                <ParametersComponent />
            </ParametersProvider>
        </BaseLayoutFactory>
    );
}
